import {ReactNode} from "react";
import {FiBarChart2} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./ChartEmptyState.module.scss";

interface ChartEmptyStateProps {
  title: string;
  message: string;
  /** What the user can do about it, shown under the message. */
  action?: ReactNode;
}

/** Says why there is no chart, rather than leaving an empty panel. */
export const ChartEmptyState = ({title, message, action}: ChartEmptyStateProps) => (
  <div className={styles.empty}>
    <Icon icon={FiBarChart2} />
    <div className={styles.title}>{title}</div>
    <div>{message}</div>
    {action}
  </div>
);
